<script>
import Vue from 'vue'
import { VSlider, VRangeSlider } from 'vuetify/lib'

export default {
  name: 'DynamicSlider',
  components: {
    VSlider,
    VRangeSlider
  },
  props: {
    thumbSize: {
      type: String,
      default: 'normal',
      validator (val) {
        if (!['small', 'normal'].includes(val)) {
          Vue.util.warn(`Invalid prop: check failed for prop "thumbSize". Expected "small" or "normal", got ${val}`)
          return false
        }
        return true
      }
    },
    value: {
      type: [Array, Number, String],
      default: null
    }
  },
  computed: {
    is () {
      return Array.isArray(this.value) ? 'VRangeSlider' : 'VSlider'
    }
  },
  render (h) {
    return h(this.is, {
      attrs: this.$attrs,
      props: this.$props,
      scopedSlots: this.$scopedSlots,
      on: { input: $e => this.$emit('input', $e) },
      class: [`slider thumb-size__${this.thumbSize}`]
    })
  }
}
</script>

<style lang="scss">
  $slider-thumb-size: 24px;

.slider {
  &.thumb-size {

    &__normal .v-slider__thumb {
      height: $slider-thumb-size;
      width: $slider-thumb-size;
      &-label {
        transform: translateY(-21px) translateX(-10px) rotate(45deg) !important;
      }
    }

    &__small .v-slider__thumb {
      transform: translateY(-50%) scale(0.5) !important;
    }
  }
  .v-slider.v-slider--horizontal {
    margin: 0;
    min-height: $slider-thumb-size;
    .v-slider {

      &__thumb {
        border: solid 1px var(--v-primary-base);
        border-width: 1px !important;
        background: #FFF !important;
        @include elevation(2);
        cursor: pointer;
        transform: translateY(-50%) scale(1) !important;

        &.primary {
          background: #FFF !important;
        }

        &:before {
          display: none;
        }

        &-container {
          &--focused {
            .v-slider__thumb {
              box-shadow: 0 0 8px 0 currentColor;
            }
          }
        }
      }

      &__track {
        height: 100%;

        &-background {
          background: var(--v-grey-lighten2) !important;
        }

        &-container {
          border-radius: 3px;
          height: 6px;
          overflow: hidden;
        }

        &-fill {
          height: 100%;
          background: linear-gradient(270deg, var(--v-primary-lighten4) 0%, var(--v-primary-base) 100%) !important;
        }
      }

      &__ticks-container .v-slider__ticks {
        border-color: transparent !important;
      }

      .v-input--slider {
        margin: 4px 0 8px 0;

        .v-input__slot {
          margin-bottom: 0;
        }

        .v-messages {
          display: none;
        }

        &.v-input--is-disabled {
          .v-slider__track-fill {
            background: var(--v-grey-lighten2) !important;
          }
        }
      }
    }
  }
}
</style>
